module.exports = __webpack_public_path__ + "img/profile_jf_l1.bf3fea6c.png";